import { useQuery } from '@tanstack/react-query';

export function useTrainingRegisterReportsFileGenerationProcessQuery({
  fileGenerationProcessId,
}) {
  return useQuery({
    enabled: !!fileGenerationProcessId,
    queryKey: [
      'trainingRegisterReports',
      'fileGenerationProcesses',
      fileGenerationProcessId,
    ],
    queryFn: async () => {
      const response = await axios.get(
        `/training_register_reports/file_generation_processes/${fileGenerationProcessId}`,
      );
      return response.data;
    },
    refetchInterval: (data) =>
      !data || ['completed', 'failed'].includes(data.data?.attributes?.status) ?
        false
      : 1000,
    refetchIntervalInBackground: true,
    retry: false,
  });
}
